<template>
  <page-outline :title="$t('administration.company_add')">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutters">
        <back-button class="btnFilter_2" :returnUrl="returnUrl"></back-button>
      </b-row>
      <form-accordion v-if="companyOptions.length"
        :title="$t('mandate.parent_node')"
        :isTitleUpperCase="false"
      >
        <b-row class="ml-2 mr-2">
          <b-col sm="6" class="form-group">
            <label>
              {{ $t("mandate.parent_node") }}
              <span class="color-red" aria-hidden="true">*</span>
            </label>

            <select
              id="parent-node"
              v-model="selectedCompany"
              class="form-control"
            >
              <option :value="null" disabled>
                {{ $t("mandate.parent_node") }}
              </option>

              <option
                v-for="company in companyOptions"
                :key="company.value"
                :value="company.value"
              >
                {{ company.text }}
              </option>
            </select>
          </b-col>
        </b-row>
      </form-accordion>
      <div v-if="selectedCompany !== null || !companyOptions.length">
        <br />
        <hr class="mx-auto" />
        <br />
        <form-accordion
          :title="$t('administration.company')"
          :isTitleUpperCase="false"
        >
          <div class="form-group"></div>
          <b-row class="ml-2 mr-2">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input
                v-model="identifier"
                isMandatory
                :inputLabel="$t('administration.identifier')"
                :placeholderValue="$t('administration.identifier')"
              >
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input
                v-model="name"
                isMandatory
                :inputLabel="$t('administration.company_name')"
                :placeholderValue="$t('administration.company_name')"
              >
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row class="ml-2 mr-2">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input
                v-model="email_reference"
                :inputLabel="$t('administration.user_email')"
                :placeholderValue="$t('administration.user_email')"
              >
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <label>
                {{ $t("administration.active") }}
              </label>
              <select class="form-control" id="sel4" v-model="active" readonly>
                <option value="0">{{ $t("administration.no") }}</option>
                <option value="1">{{ $t("administration.in_prgrss") }}</option>
                <option value="2">{{ $t("administration.yes") }}</option>
              </select>
            </b-col>
          </b-row>
          <b-row class="ml-2 mr-2">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input
                v-model="address"
                isMandatory
                :inputLabel="$t('administration.address')"
                :placeholderValue="$t('administration.address')"
              >
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input
                v-model="city"
                isMandatory
                :inputLabel="$t('administration.city')"
                :placeholderValue="$t('administration.city')"
              >
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input
                v-model="zip_code"
                isMandatory
                :inputLabel="$t('administration.zip_code')"
                :placeholderValue="$t('administration.zip_code')"
              >
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input
                isMandatory
                :inputType="'listeSelect'"
                :inputLabel="$t('administration.country')"
              >
                <select class="form-control" v-model="country">
                  <option
                    v-for="opt in countryOptions"
                    :key="opt.iso2"
                    :value="opt.iso2"
                  >
                    {{ $t("countries." + opt.key) }}
                  </option>
                </select>
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </form-accordion>
        <br />
        <form-accordion
          :title="$t('administration.user')"
          :isTitleUpperCase="false"
          :open="false"
          v-if="false"
        >
          <div class="form-group"></div>
          <b-row class="ml-2 mr-2">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input
                v-model="login"
                isMandatory
                :inputLabel="$t('administration.login')"
                :placeholderValue="$t('administration.login')"
              >
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input
                v-model="username"
                isMandatory
                :inputLabel="$t('administration.username')"
                :placeholderValue="$t('administration.username')"
              >
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row class="ml-2 mr-2">
            <b-col sm="6" class="form-group">
              <label>
                {{ $t("administration.active") }}
              </label>
              <select
                class="form-control"
                id="sel4"
                v-model="active_user"
                readonly
              >
                <option value="0">{{ $t("administration.no") }}</option>
                <option value="1">{{ $t("administration.in_prgrss") }}</option>
                <option value="2">{{ $t("administration.yes") }}</option>
              </select>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input
                v-model="password"
                :inputLabel="$t('administration.password')"
                inputType="password"
                :placeholderValue="$t('administration.password')"
              >
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </form-accordion>
        <br />
        <form-accordion
          :title="$t('administration.right')"
          :isTitleUpperCase="false"
          :open="false"
          v-if="false"
        >
          <div class="form-group"></div>
          <b-row class="ml-2 mr-2">
            <b-col
              sm="6"
              lg="4"
              xl="3"
              class="form-group"
              v-for="(result, id) in rights"
              :key="result + '-' + id"
            >
              <b-form-checkbox v-model="select_rights" :value="result">
                {{
                  $t("rights.db_rights." + result) ===
                  "rights.db_rights." + result
                    ? result
                    : $t("rights.db_rights." + result)
                }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </form-accordion>
        <br />
        <hr class="mx-auto" />
        <br />
        <form-accordion
          :title="$t('administration.company_prfls')"
          :isTitleUpperCase="false"
        >
          <b-col cols="3" class="no-gutter px-0 ml-2 mr-2">
            <label>Roles</label>
            <a
              id="profile-picker-link-default"
              class="combo-list-field d-flex justify-content-between"
              href="#"
            >
              <span
                :class="
                  'fixed-span-size ' +
                  (profileDisplay.nb > 0 ? 'filter-item-input-complete' : '')
                "
              >
                {{ profileDisplay.label }}
              </span>
              <i
                class="fa-light fa-chevron-down"
                size="17px"
                id="status-chevron"
              ></i>
            </a>
            <b-popover
              target="profile-picker-link-default"
              :title="$t('administration.select_profile')"
              triggers="focus"
              placement="bottom"
            >
              <span
                v-for="(profile, index) in templates"
                :key="'filtered-profile-' + profile.name_template + '-' + index"
              >
                <b-form-checkbox
                  v-model="profile.active"
                  :value="1"
                  :unchecked-value="0"
                >
                  <span>{{ profile.label }}</span>
                </b-form-checkbox>
              </span>
            </b-popover>
          </b-col>
        </form-accordion>
        <br />
        <hr class="mx-auto" />
        <br />
        <form-accordion
          :title="$t('mandate.technical_access.title')"
          :isTitleUpperCase="false"
        >
          <b-form-checkbox v-model="technicalUser">{{
            $t("mandate.technical_access.technical_user")
          }}</b-form-checkbox>
          <b-col cols="12" class="px-0 mt-3" v-if="technicalUser">
            <form-accordion
              :title="$t('common.security.certificat')"
              :isTitleUpperCase="false"
            >
              <b-row class="d-flex form-group">
                <b-col sm="6" class="form-group">
                  <form-write-group-label-input v-model="form.name" isMandatory
                    :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row
                v-if="certificateText !== '' || form.stateCertificat === 0"
                class="d-flex justify-content-center align-items-center form-group"
              >
                <b-col :sm="certificateText === '' ? 6 : 12" class="form-group">
                  <label for="certificate-content">
                    {{ $t("common.security.certificat_file_content") }}
                    <span class="color-red" aria-hidden="true">*</span>
                  </label>

                  <b-form-textarea
                    id="certificate-content"
                    v-model="certificateText"
                    required
                    style="max-height: none"
                    :placeholder="$t('common.security.enter_something')"
                    rows="6"
                    @input="processCertificat"
                  />
                </b-col>

                <b-col
                  v-if="certificateText === '' && form.stateCertificat === 0"
                  sm="6"
                  class="form-group d-flex flex-column"
                >
                  <label for="certificate-file">
                    {{ $t("common.security.certificat_file") }}
                  </label>

                  <input
                    id="certificate-file"
                    type="file"
                    accept=".pem,.crt"
                    @change="handleFileUploadCertificat"
                  />
                </b-col>
              </b-row>
              <b-row class="d-flex align-items-center form-group">
                <b-col sm="6" class="form-group normal-font">
                  <form-read-group-label-input
                    :inputValue="form.startDate"
                    :inputLabel="$t('common.security.startDate')"
                    :placeholderValue="$t('common.security.startDate')"
                  >
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="6" class="form-group normal-font">
                  <form-read-group-label-input
                    :inputValue="form.endDate"
                    :inputLabel="$t('common.security.endDate')"
                    :placeholderValue="$t('common.security.endDate')"
                  >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              <b-row class="d-flex align-items-center form-group">
                <b-col sm="6" class="form-group normal-font">
                  <form-read-group-label-input
                    :inputValue="form.deliveredBy"
                    :inputLabel="$t('common.security.deliveredBy')"
                    :placeholderValue="$t('common.security.deliveredBy')"
                  >
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="6" class="form-group normal-font">
                  <form-read-group-label-input
                    :inputValue="form.deliveredTo"
                    :inputLabel="$t('common.security.deliveredTo')"
                    :placeholderValue="$t('common.security.deliveredTo')"
                  >
                  </form-read-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <br />
            <hr class="mx-auto" />
            <br />
            <form-accordion
              :title="$t('common.security.private_key')"
              :isTitleUpperCase="false"
            >
              <b-row
                v-if="form.statePrivateKey === 0"
                class="d-flex justify-content-center align-items-center form-group"
              >
                <b-col :sm="privateKeyText === '' ? 6 : 12" class="form-group">
                  <label for="private-key-content">
                    {{ $t("common.security.private_key_file_content") }}
                    <span class="color-red" aria-hidden="true">*</span>
                  </label>

                  <b-form-textarea
                    id="private-key-content"
                    v-model="privateKeyText"
                    required
                    style="max-height: none"
                    :placeholder="$t('common.security.enter_something')"
                    rows="6"
                    @input="processPrivateKey"
                  />
                </b-col>

                <b-col
                  v-if="privateKeyText === ''"
                  sm="6"
                  class="form-group d-flex flex-column"
                >
                  <label for="private-key-file">
                    {{ $t("common.security.private_key_file") }}
                  </label>

                  <input
                    id="private-key-file"
                    type="file"
                    accept=".pem, .key"
                    @change="handleFileUploadPrivateKey"
                  />
                </b-col>
              </b-row>
              <b-row
                class="d-flex justify-content-center align-items-center form-group"
              >
                <b-col sm="6" class="form-group">
                  <form-write-group-label-input
                    v-model="form.password"
                    :inputLabel="$t('common.security.password')"
                    :placeholderValue="$t('common.security.password')"
                  >
                  </form-write-group-label-input>
                </b-col>
                <b-col sm="6" class="form-group"></b-col>
              </b-row>
            </form-accordion>
          </b-col>
        </form-accordion>
        <form-accordion open :title="$t('mandate.remittance_generation.parameter')">
            <form-accordion open :title="$t('mandate.remittance_generation.sdd_remittance_generation')">
              <div class="sdd-generation-settings">
                <!-- Déclenchement manuel -->
                <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="generationManual"
                      type="radio"
                      class="custom-control-input"
                      name="generationRadio"
                      value="manual"
                      v-model="generationMode"
                      :disabled="!doesEdit"
                    />
                    <label class="custom-control-label" for="generationManual">
                      {{ $t('mandate.remittance_generation.manual_trigger') }}
                    </label>
                  </div>
                </div>

                <!-- Fin du batch -->
                <!-- <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="generationBatch"
                      type="radio"
                      class="custom-control-input"
                      name="generationRadio"
                      value="batch"
                      v-model="generationMode"
                      :disabled="!doesEdit"
                    />
                    <label class="custom-control-label" for="generationBatch">
                      À la fin du batch: Intégration des fichiers de transaction
                    </label>
                  </div>
                </div> -->

                <!-- Dans l'intervalle -->
                <div class="generation-row interval-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="generationInterval"
                      type="radio"
                      class="custom-control-input"
                      name="generationRadio"
                      value="auto"
                      v-model="generationMode"
                      :disabled="!doesEdit"
                    />
                    <label class="custom-control-label" for="generationInterval">
                      {{ $t('mandate.remittance_generation.within_interval') }}
                    </label>
                  </div>

                  <div class="interval-selects">
                    <select
                      class="form-control form-control-sm"
                      v-model="generationFrequency"
                      :disabled="!doesEdit || generationMode !== 'auto'"
                    >
                      <option value="daily">{{ $t('mandate.remittance_generation.daily') }}</option>
                      <option value="weekly">{{ $t('mandate.remittance_generation.weekly') }}</option>
                    </select>

                    <select
                      class="form-control form-control-sm space"
                      v-model="generationTime"
                      :disabled="!doesEdit || generationMode !== 'auto'"
                    >
                      <option
                        v-for="hour in 24"
                        :key="hour - 1"
                        :value="`${String(hour - 1).padStart(2, '0')}-${String(
                          hour % 24,
                        ).padStart(2, '0')}`"
                      >
                        {{ hour - 1 }}h - {{ hour % 24 }}h
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </form-accordion>
            <form-accordion open :title="$t('mandate.remittance_generation.sdd_remittance_file_generation')">
              <div class="sdd-generation-settings">
                <!-- Déclenchement manuel -->
                <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sddgenerationManual"
                      type="radio"
                      class="custom-control-input"
                      name="sddgenerationRadio"
                      value="manual"
                      v-model="generationModeSDD"
                      :disabled="!doesEdit"
                    />
                    <label class="custom-control-label" for="sddgenerationManual">
                      {{ $t('mandate.remittance_generation.manual_trigger') }}
                    </label>
                  </div>
                </div>

                <!-- Fin du batch -->
                <!-- <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="generationBatch"
                      type="radio"
                      class="custom-control-input"
                      name="generationRadio"
                      value="batch"
                      v-model="generationMode"
                      :disabled="!doesEdit"
                    />
                    <label class="custom-control-label" for="generationBatch">
                      À la fin du batch: Génération des remises SDD
                    </label>
                  </div>
                </div> -->

                <!-- Dans l'intervalle -->
                <div class="generation-row interval-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sddgenerationInterval"
                      type="radio"
                      class="custom-control-input"
                      name="sddgenerationRadio"
                      value="auto"
                      v-model="generationModeSDD"
                      :disabled="!doesEdit"
                    />
                    <label class="custom-control-label" for="sddgenerationInterval">
                      {{ $t('mandate.remittance_generation.within_interval') }}
                    </label>
                  </div>

                  <div class="interval-selects">
                    <select
                      class="form-control form-control-sm"
                      v-model="generationFrequencySDD"
                      :disabled="!doesEdit || generationModeSDD !== 'auto'"
                    >
                      <option value="daily">{{ $t('mandate.remittance_generation.daily') }}</option>
                      <option value="weekly">{{ $t('mandate.remittance_generation.weekly') }}</option>
                    </select>

                    <select
                      class="form-control form-control-sm space"
                      v-model="generationTimeSDD"
                      :disabled="!doesEdit || generationModeSDD !== 'auto'"
                    >
                      <option
                        v-for="hour in 24"
                        :key="`sdd-${hour - 1}`"
                :value="`${String(hour - 1).padStart(2, '0')}-${String(hour % 24).padStart(2, '0')}`"
                      >
                        {{ hour - 1 }}h - {{ hour % 24 }}h
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </form-accordion>
            <!-- Génération des remises SCT -->
            <form-accordion open :title="$t('mandate.remittance_generation.sct_remittance_generation')">
              <div class="sct-generation-settings">
                <!-- Déclenchement manuel -->
                <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctGenerationManual"
                      type="radio"
                      class="custom-control-input"
                      name="sctGenerationRadio"
                      value="manual"
                      v-model="sctGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label class="custom-control-label" for="sctGenerationManual">
                      {{ $t('mandate.remittance_generation.manual_trigger') }}
                    </label>
                  </div>
                </div>

                <!-- Après le batch -->
                <!-- <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctGenerationBatch"
                      type="radio"
                      class="custom-control-input"
                      name="sctGenerationRadio"
                      value="batch"
                      v-model="sctGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label class="custom-control-label" for="sctGenerationBatch">
                      Après la fin du batch : Génération des remises SCT
                    </label>
                  </div>
                </div> -->

                <!-- Après la création du fichier SCT via -->
                <!-- <div class="generation-row sct-file-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctGenerationFile"
                      type="radio"
                      class="custom-control-input"
                      name="sctGenerationRadio"
                      value="file"
                      v-model="sctGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label class="custom-control-label" for="sctGenerationFile">
                      Après la création du fichier SCT via :
                    </label>
                  </div>

                  <div class="sct-file-options">
                    <div class="custom-control custom-checkbox">
                      <input
                        id="sctFileIntegration"
                        type="checkbox"
                        class="custom-control-input"
                        v-model="sctFileIntegration"
                        :disabled="!doesEdit || sctGenerationMode !== 'file'"
                      />

                      <label class="custom-control-label" for="sctFileIntegration">
                        Intégration d'un fichier
                      </label>
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        id="sctFileWeb"
                        type="checkbox"
                        class="custom-control-input"
                        v-model="sctFileWeb"
                        :disabled="!doesEdit || sctGenerationMode !== 'file'"
                      />

                      <label class="custom-control-label" for="sctFileWeb">
                        Web
                      </label>
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        id="sctFileWebService"
                        type="checkbox"
                        class="custom-control-input"
                        v-model="sctFileWebService"
                        :disabled="!doesEdit || sctGenerationMode !== 'file'"
                      />

                      <label class="custom-control-label" for="sctFileWebService">
                        Web Service
                      </label>
                    </div>
                  </div>
                </div> -->

                <!-- Dans l'intervalle -->
                <div class="generation-row interval-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctGenerationInterval"
                      type="radio"
                      class="custom-control-input"
                      name="sctGenerationRadio"
                      value="auto"
                      v-model="sctGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label class="custom-control-label" for="sctGenerationInterval">
                      {{ $t('mandate.remittance_generation.within_interval') }}
                    </label>
                  </div>

                  <div class="interval-selects">
                    <select
                      class="form-control form-control-sm"
                      v-model="sctGenerationFrequency"
                      :disabled="!doesEdit || sctGenerationMode !== 'auto'"
                    >
                      <option value="daily">{{ $t('mandate.remittance_generation.daily') }}</option>

                      <option value="weekly">{{ $t('mandate.remittance_generation.weekly') }}</option>
                    </select>

                    <select
                      class="form-control form-control-sm space"
                      v-model="sctGenerationTime"
                      :disabled="!doesEdit || sctGenerationMode !== 'auto'"
                    >
                      <option
                        v-for="hour in 24"
                        :key="`sct-generation-${hour - 1}`"
                        :value="`${String(hour - 1).padStart(2, '0')}-${String(
                          hour % 24,
                        ).padStart(2, '0')}`"
                      >
                        {{ hour - 1 }}h - {{ hour % 24 }}h
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </form-accordion>

            <!-- Génération du fichier de remises SCT -->
            <form-accordion open :title="$t('mandate.remittance_generation.sct_remittance_file_generation')">
              <div class="sct-file-generation-settings">
                <!-- Déclenchement manuel -->
                <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctFileGenerationManual"
                      type="radio"
                      class="custom-control-input"
                      name="sctFileGenerationRadio"
                      value="manual"
                      v-model="sctFileGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label
                      class="custom-control-label"
                      for="sctFileGenerationManual"
                    >
                      {{ $t('mandate.remittance_generation.manual_trigger') }}
                    </label>
                  </div>
                </div>

                <!-- À la fin du batch -->
                <!-- <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctFileGenerationBatch"
                      type="radio"
                      class="custom-control-input"
                      name="sctFileGenerationRadio"
                      value="batch"
                      v-model="sctFileGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label
                      class="custom-control-label"
                      for="sctFileGenerationBatch"
                    >
                      À la fin du batch : Génération des remises SCT
                    </label>
                  </div>
                </div> -->

                <!-- Dans l'intervalle -->
                <div class="generation-row interval-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctFileGenerationInterval"
                      type="radio"
                      class="custom-control-input"
                      name="sctFileGenerationRadio"
                      value="auto"
                      v-model="sctFileGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label
                      class="custom-control-label"
                      for="sctFileGenerationInterval"
                    >
                      {{ $t('mandate.remittance_generation.within_interval') }}
                    </label>
                  </div>

                  <div class="interval-selects">
                    <select
                      class="form-control form-control-sm"
                      v-model="sctFileGenerationFrequency"
                      :disabled="!doesEdit || sctFileGenerationMode !== 'auto'"
                    >
                      <option value="daily">{{ $t('mandate.remittance_generation.daily') }}</option>

                      <option value="weekly">{{ $t('mandate.remittance_generation.weekly') }}</option>
                    </select>

                    <select
                      class="form-control form-control-sm space"
                      v-model="sctFileGenerationTime"
                      :disabled="!doesEdit || sctFileGenerationMode !== 'auto'"
                    >
                      <option
                        v-for="hour in 24"
                        :key="`sct-file-generation-${hour - 1}`"
                        :value="`${String(hour - 1).padStart(2, '0')}-${String(
                          hour % 24,
                        ).padStart(2, '0')}`"
                      >
                        {{ hour - 1 }}h - {{ hour % 24 }}h
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </form-accordion>
            <form-accordion
  open
  :title="$t('mandate.remittance_generation.expiring_extraction')"
>
  <div class="expiring-mandates-settings">
    <div class="generation-row interval-row">
      <div class="custom-control custom-radio">
      <label for="expiringMandatesType">
        {{ $t('mandate.remittance_generation.type') }}
      </label>
      </div>
 <div class="interval-selects-type">
      <select
        id="expiringMandatesType"
        class="form-control form-control-sm"
        v-model="expiringMandatesType"
        :disabled="!doesEdit"
      >
        <option value="manual">
          {{ $t('mandate.remittance_generation.none') }}
        </option>
        <option value="ftp">
          {{ $t('mandate.remittance_generation.ftp') }}
        </option>
      </select>
      </div>
    </div>
  </div>
</form-accordion>
        </form-accordion>
        <b-row
          class="accordionForm form-group mt-3 justify-content-end no-gutters"
        >
          <b-button class="btnFilter_2" @click="createCompanyv2()">
            <i class="fa-light fa-save"></i>
            <span>{{ $t("common.sve") }}</span>
          </b-button>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import moment from "moment";
import FormAccordion from "@/components/common/FormAccordion.vue"
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import formReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue"
import PageOutline from "@/components/common/PageOutline.vue"
import { errorMessageAlert } from "@/helpers/alert"
import backButton from "@/components/common/backButton.vue"
import { loadPage } from "@/helpers/routing"
import forge from "node-forge"
// import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'

export default {
  name: "AddCompany",
  components: {
    "form-accordion": FormAccordion,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    "back-button": backButton,
    "form-read-group-label-input": formReadGroupLabelInput,
  },
  data() {
    return {
      identifier: "",
      name: "",
      email_reference: "",
      active: "0",
      login: "",
      address: "",
      city: "",
      zip_code: "",
      country: "",
      countryOptions: [
        { iso2: "FR", key: "france" },
        { iso2: "DE", key: "allemagne" },
        { iso2: "IT", key: "italie" },
        { iso2: "ES", key: "espagne" },
        { iso2: "BE", key: "belgique" },
        { iso2: "LU", key: "luxembourg" },
        { iso2: "NL", key: "pays_bas" },
        { iso2: "PT", key: "portugal" },
        { iso2: "IE", key: "irlande" },
        { iso2: "AT", key: "autriche" },
        { iso2: "FI", key: "finlande" },
        { iso2: "SE", key: "suede" },
        { iso2: "DK", key: "danemark" },
        { iso2: "NO", key: "norvege" },
        { iso2: "IS", key: "islande" },
        { iso2: "CH", key: "suisse" },
        { iso2: "PL", key: "pologne" },
        { iso2: "CZ", key: "republique_tcheque" },
        { iso2: "SK", key: "slovaquie" },
        { iso2: "SI", key: "slovenie" },
        { iso2: "HR", key: "croatie" },
        { iso2: "EE", key: "estonie" },
        { iso2: "LV", key: "lettonie" },
        { iso2: "LT", key: "lituanie" },
        { iso2: "MT", key: "malte" },
        { iso2: "CY", key: "chypre" },
        { iso2: "RO", key: "roumanie" },
        { iso2: "BG", key: "bulgarie" },
        { iso2: "HU", key: "hongrie" },
        { iso2: "GR", key: "grece" },
      ],
      cdtr_scheme_id: "",
      username: "",
      active_user: "0",
      password: "",
      rights: [],
      select_rights: [],
      templates: [
        {
          name_template: "client_admin",
          label: "Admin",
          active: 1,
        },
        {
          name_template: "client_user",
          label: "User",
          active: 1,
        }
      ],
      redirection: this.$engine.company.redirection,
      returnUrl: "/company/",
      technicalUser: false,
      form: {
        state: 0,
        statePrivateKey: 0,
        stateCertificat: 0,
        privateKey: "",
        certificate: "",
        startDate: "",
        endDate: "",
        deliveredBy: "",
        deliveredTo: "",
        name: "",
        nameDisplay: "",
        pod: "",
        password: "",
        id: "",
      },
      certificateText: "",
      privateKeyText: "",
      selectedCompany: null,
      companies: [],
      accountId: "",
      generationMode: "",
      generationFrequency: "",
      generationTime: "",
      generationModeSDD: "",
      generationFrequencySDD: "",
      generationTimeSDD: "",
      // Génération des remises SCT
      sctGenerationMode: "",
      sctGenerationFrequency: "",
      sctGenerationTime: "",

      sctFileIntegration: false,
      sctFileWeb: false,
      sctFileWebService: false,

      // Génération du fichier de remises SCT
      sctFileGenerationMode: "",
      sctFileGenerationFrequency: "",
      sctFileGenerationTime: "",
      doesEdit: true,
      expiringMandatesType: 'none'
    }
  },
  computed: {
    profileDisplay() {
      let realProfileList = this.templates.filter((elem) => elem.active)
      if (realProfileList.length === 0) {
        return {
          label: this.$t("administration.select_profile"),
          nb: 0,
        };
      } else if (realProfileList.length < 3) {
        return {
          label: realProfileList.map((elem) => elem.label).join(", "),
          nb: 1,
        };
      } else {
        return {
          label: this.$t("administration.selected_profile_many", {
            nb: realProfileList.length,
          }),
          nb: realProfileList.length,
        };
      }
      return realProfileList
    },
    companyOptions () {
      const companies = this.$engine.company.hierarchy || [];

      // Fonction récursive qui génère les options avec indentation
      const buildOptions = (parentId = "", depth = 0) => {
        const children = companies.filter(account => account.idParent === parentId)
        if (children.length === 0) return []
        return children.flatMap(account => [
          {
            value: account.idAccount,
            text: (depth === 0 ? "" : "+---".repeat(depth)) + account.name
          },
          ...buildOptions(account.idAccount, depth + 1)
        ])
      }

      const options = buildOptions("")
      return options
    },
    realProfileList () {
      let that = this
      const list = []
      for (const property in that.profiles) {
        const profile = that.profiles[property]
        list.push({
          tag: property,
          label: profile.libelle,
          state: profile.state,
          id: profile.id_rights_profile
        })
      }
      return list
    }
  },
  created() {
    let that = this
    this.returnUrl = this.returnUrl + this.redirection
    that.makeRightsList()
    this.accountId = this.$engine.user.get().id
    this.loadCompanies()
  },
  methods: {
    normalizeNationalId(cc, raw) {
      if (!raw) return { nid: "", note: "" }

      let nid = String(raw).replace(/\s+/g, "")
      let note = "";

      // Détection ICS existant
      const maybeIcs = String(raw).trim().toUpperCase()
      if (/^[A-Z]{2}\d{2}[A-Z0-9]{3}\d{15}$/.test(maybeIcs)) {
        const last15 = maybeIcs.slice(-15)
        return {
          nid: last15.slice(-9),
          note: "ICS détecté, extraction depuis les 15 digits",
        };
      }

      if (cc === "FR") {
        const digits = nid.replace(/\D/g, "");
        if (/^\d{14}$/.test(digits)) {
          nid = digits.slice(0, 9);
          return { nid, note: `SIRET détecté, SIREN utilisé: ${nid}` };
        }
        if (/^\d{9}$/.test(digits)) {
          return { nid: digits, note: `SIREN utilisé: ${digits}` };
        }
        nid = nid.toUpperCase();
        if (/[^A-Z0-9]/.test(nid))
          return { nid: "", note: "Identifiant FR invalide" };
        return { nid, note: "Identifiant FR non standard" };
      }

      if (cc === "BE") {
        // Belgique : BCE format 0xxx.xxx.xxx → on retire les points
        const digits = nid.replace(/\D/g, "");
        if (/^\d{10}$/.test(digits)) {
          return { nid: digits, note: `BCE utilisé: ${digits}` };
        }
        return {
          nid: "",
          note: "Identifiant BE invalide - BCE attendu (10 chiffres)",
        };
      }

      if (cc === "CH") {
        // Suisse : IDE/UID format CHE-xxx.xxx.xxx → on retire CHE- et les points
        const cleaned = nid.replace(/^CHE[-.]?/i, "").replace(/\D/g, "");
        if (/^\d{9}$/.test(cleaned)) {
          return { nid: cleaned, note: `IDE/UID CH utilisé: ${cleaned}` };
        }
        return {
          nid: "",
          note: "Identifiant CH invalide - IDE/UID attendu (9 chiffres)",
        };
      }

      if (cc === "DE") {
        // Allemagne : Steuernummer ou Handelsregisternummer → on garde alphanumérique
        nid = nid.replace(/[\s\-./]/g, "").toUpperCase();
        if (/^[A-Z0-9]{5,15}$/.test(nid)) {
          return { nid, note: `Identifiant DE utilisé: ${nid}` };
        }
        return { nid: "", note: "Identifiant DE invalide" };
      }

      if (cc === "IT") {
        // Italie : Codice Fiscale (16 alphanum) ou P.IVA (11 chiffres)
        const digits = nid.replace(/\D/g, "");
        if (/^\d{11}$/.test(digits)) {
          return { nid: digits, note: `P.IVA IT utilisé: ${digits}` };
        }
        nid = nid.toUpperCase().replace(/[^A-Z0-9]/g, "");
        if (/^[A-Z0-9]{16}$/.test(nid)) {
          return { nid, note: `Codice Fiscale IT utilisé: ${nid}` };
        }
        return { nid: "", note: "Identifiant IT invalide" };
      }

      if (cc === "ES") {
        // Espagne : NIF/CIF format X12345678 → alphanumérique 9 chars
        nid = nid.toUpperCase().replace(/[^A-Z0-9]/g, "");
        if (/^[A-Z0-9]{9}$/.test(nid)) {
          return { nid, note: `NIF/CIF ES utilisé: ${nid}` };
        }
        return { nid: "", note: "Identifiant ES invalide" };
      }

      if (cc === "NL") {
        // Pays-Bas : KvK 8 chiffres ou BTW-id 12 chars
        const digits = nid.replace(/\D/g, "");
        if (/^\d{8}$/.test(digits)) {
          return { nid: digits, note: `KvK NL utilisé: ${digits}` };
        }
        nid = nid.toUpperCase().replace(/[^A-Z0-9]/g, "");
        if (/^[A-Z0-9]{12}$/.test(nid)) {
          return { nid, note: `BTW-id NL utilisé: ${nid}` };
        }
        return { nid: "", note: "Identifiant NL invalide" };
      }

      if (cc === "PT") {
        // Portugal : NIPC 9 chiffres
        const digits = nid.replace(/\D/g, "");
        if (/^\d{9}$/.test(digits)) {
          return { nid: digits, note: `NIPC PT utilisé: ${digits}` };
        }
        return { nid: "", note: "Identifiant PT invalide" };
      }

      if (cc === "AT") {
        // Autriche : Firmenbuchnummer format FN123456a → alphanumérique
        nid = nid.toUpperCase().replace(/[^A-Z0-9]/g, "");
        if (/^[A-Z0-9]{5,12}$/.test(nid)) {
          return { nid, note: `Identifiant AT utilisé: ${nid}` };
        }
        return { nid: "", note: "Identifiant AT invalide" };
      }

      if (cc === "PL") {
        // Pologne : NIP 10 chiffres
        const digits = nid.replace(/\D/g, "");
        if (/^\d{10}$/.test(digits)) {
          return { nid: digits, note: `NIP PL utilisé: ${digits}` };
        }
        return { nid: "", note: "Identifiant PL invalide" };
      }

      // Fallback générique pour les autres pays
      nid = nid.toUpperCase().replace(/[\s\-./]/g, "");
      if (/[^A-Z0-9]/.test(nid))
        return { nid: "", note: "Identifiant national non alphanumérique" };
      return { nid, note: "Identifiant générique utilisé" };
    },

    lettersToDigits(s) {
      let out = "";
      for (let i = 0; i < s.length; i++) {
        const code = s.charCodeAt(i);
        if (code >= 48 && code <= 57) out += s[i];
        else if (code >= 65 && code <= 90) out += code - 55;
      }
      return out;
    },

    mod97(numStr) {
      let rem = 0;
      for (let i = 0; i < numStr.length; i += 7) {
        const part = String(rem) + numStr.substr(i, 7);
        rem = parseInt(part, 10) % 97;
      }
      return rem;
    },

    computeICSFromISO2(cc, nationalIdRaw, businessCode = "ZZZ") {
      const iso2 = (cc || "").trim().toUpperCase();
      if (!/^[A-Z]{2}$/.test(iso2)) return "";

      const { nid } = this.normalizeNationalId(iso2, nationalIdRaw);
      if (!nid) return "";

      const nidDigits = String(nid).replace(/\D/g, "");
      const nidPadded15 = nidDigits.padStart(15, "0");

      const b = (businessCode || "ZZZ").toUpperCase();
      if (!/^[A-Z0-9]{3}$/.test(b)) return "";

      const rearr = `${b}${nidPadded15}${iso2}00`;
      const numeric = this.lettersToDigits(rearr);
      const remainder = this.mod97(numeric);
      const check = String(98 - remainder).padStart(2, "0");

      return `${iso2}${check}${b}${nidPadded15}`;
    },
    createCompanyv2 () {
      const that = this;

      if (!this.identifier) {
        this.$f7.alert(
          this.$i18n.t("company.missing_company_identifier"),
          "Error",
        );
        return;
      } else if (!this.name) {
        this.$f7.alert(this.$i18n.t("company.missing_company_name"), "Error");
        return;
      } else if (!this.address) {
        this.$f7.alert(
          this.$i18n.t("company.missing_company_address"),
          "Error",
        );
        return;
      } else if (!this.city) {
        this.$f7.alert(this.$i18n.t("company.missing_company_city"), "Error");
        return;
      } else if (!this.zip_code) {
        this.$f7.alert(
          this.$i18n.t("company.missing_company_zip_code"),
          "Error",
        );
        return;
      } else if (!this.country) {
        this.$f7.alert(
          this.$i18n.t("company.missing_company_country"),
          "Error",
        );
        return;
      }

      let selectedRoles = this.templates.filter(elem => elem.active ).map(elem => elem.name_template)

      if (this.technicalUser) {
        if (!this.form.name) {
          this.$f7.alert(
            this.$i18n.t("common.security.certif_name_missing"),
            "Error",
          );
          return;
        } else if (!this.form.certificate) {
          this.$f7.alert(
            this.$i18n.t("common.security.certificate_file_content_missing"),
            "Error",
          );
          return;
        } else if (!this.form.startDate) {
          this.$f7.alert(
            this.$i18n.t("common.security.start_date_missing"),
            "Error",
          );
          return;
        } else if (!this.form.endDate) {
          this.$f7.alert(
            this.$i18n.t("common.security.end_date_missing"),
            "Error",
          );
          return;
        } else if (!this.form.privateKey) {
          this.$f7.alert(
            this.$i18n.t("common.security.private_key_file_content_missing"),
            "Error",
          );
          return;
        }
      }

      this.cdtr_scheme_id = this.computeICSFromISO2(
        this.country,
        this.identifier,
        "ZZZ"
      );
      const parameter = this.buildSettingsParameter()
      if (!parameter) {
        return
      }

      // Création de la sécurité AVANT la société
      if (this.technicalUser) {
        let that = this
        this.$engine.security.private_keys.create({
          idPod: this.form.pod,
          name: this.form.name,
          privateKey: this.form.privateKey,
          password: this.form.password,
          passwordVerif: this.form.password,
          type: "SSL",
        })
        .then(privateKeyResponse => {
          let id_privatekey = privateKeyResponse.data.idPrivateKey
          that.$engine.security.certificates.create({
            idPod: that.form.pod,
            name: that.form.name,
            certificate: that.form.certificate,
            startDate: that.convertToDbDateTime(that.form.startDate),
            endDate: that.convertToDbDateTime(that.form.endDate),
            deliveredBy: that.form.deliveredBy,
            deliveredTo: that.form.deliveredTo,
            commonName: that.form.nameDisplay,
            type: "SSL",
            active: that.getActiveStatus(
              that.form.startDate,
              that.form.endDate
            )
          })
          .then(certificateResponse => {
            let id_certificate = certificateResponse.data.idCertificat
            that.$engine.company.addCompanyv2({
              account: {
                identifier: that.identifier,
                name: that.name,
                email_reference: that.email_reference || "##NULL##",
                active: that.active,
                address: that.address,
                city: that.city,
                zip_code: that.zip_code,
                country: that.country,
                cdtr_scheme_id: this.cdtr_scheme_id || "##NULL##",
                id_parent: Number(this.selectedCompany),
                id_certificate: id_certificate,
                id_privatekey: id_privatekey
              },
              templates: [...selectedRoles, "client_api"],
              parameter
            })
            .then(() => {
              that.$f7.modal({
                title: that.$i18n.t("administration.company_added"),
                buttons: [
                  {
                    text: "OK",
                    onClick() {
                      loadPage(that, { url: "/company/-1" });
                    },
                  },
                ],
              })
            })
            .catch(errCompany => {
              errorMessageAlert(errCompany, that);
            })
          })
          .catch(errCert => {
            errorMessageAlert(errCert, that);
          })
        })
        .catch(errPK => {
          errorMessageAlert(errPK, that);
        })
      } else {
        const payload = {
          account: {
            identifier: this.identifier,
            name: this.name,
            email_reference: this.email_reference || "##NULL##",
            active: this.active,
            address: this.address,
            city: this.city,
            zip_code: this.zip_code,
            country: this.country,
            cdtr_scheme_id: this.cdtr_scheme_id || "##NULL##",
            id_parent: Number(this.selectedCompany)
          },
          templates: selectedRoles,
          parameter
        };

        // Création de la société
        this.$engine.company.addCompanyv2(payload)
        .then(resp => {
          that.$f7.modal({
            title: that.$i18n.t("administration.company_added"),
            buttons: [
              {
                text: "OK",
                onClick() {
                  loadPage(that, { url: "/company/-1" });
                },
              },
            ],
          })
        })
        .catch(err => {
          errorMessageAlert(e, that);
        })
      }
    },
    makeRightsList() {
      let allStatus = Object.keys(this.$engine.rights.getAll());
      let realStatusList = Object.keys(allStatus).filter(
        (elem) => allStatus[elem],
      );
      this.rights = allStatus;
      //console.log('rights', this.rights)
    },
    createCompany () {
      let that = this;
      let regexPassword =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/;
      if (!this.identifier) {
        this.$f7.alert(
          that.$i18n.t("company.missing_company_identifier"),
          "Error",
        );
      } else if (!this.name) {
        that.$f7.alert(that.$i18n.t("company.missing_company_name"), "Error");
      } else if (!this.email_reference) {
        that.$f7.alert(that.$i18n.t("company.missing_company_email"), "Error");
      } else if (!this.login) {
        that.$f7.alert(that.$i18n.t("company.missing_login"), "Error");
      } else if (!this.username) {
        that.$f7.alert(that.$i18n.t("usercompany.missing_name"), "Error");
      } else if (!this.password) {
        that.$f7.alert(that.$i18n.t("company.missing_password"), "Error");
      } else if (!regexPassword.test(this.password)) {
        that.$f7.alert(
          that.$i18n.t("profilesPage.password_wrong_format"),
          "Error",
        );
      } else if (this.select_rights.length <= 0) {
        that.$f7.alert(that.$i18n.t("company.missing_rights"), "Error");
      } else {
        this.$engine.company
          .addCompany(
            {
              identifier: this.identifier,
              name: this.name,
              email_reference: this.email_reference,
              active: this.active,
            },
            {
              login: this.login,
              name: this.username,
              password: this.password,
              active: this.active_user,
            },
            this.select_rights,
          )
          .then((resp) => {
            that.$f7.modal({
              title: that.$i18n.t("administration.user_added"),
              buttons: [
                {
                  text: "OK",
                  onClick: function () {
                    return;
                  },
                },
              ],
            });
            loadPage(that, { url: "/company/" + that.redirection });
          })
          .catch((e) => {
            errorMessageAlert(e, that);
            that.$f7.modal({
              title: that.$i18n.t("administration.user_addition_error"),
              buttons: [
                {
                  text: "OK",
                  onClick: function () {
                    return;
                  },
                },
              ],
            });
          });
      }
    },
    cancelCertificat() {
      this.form.stateCertificat = 1;
      this.certificateText = "";
      this.form.startDate = this.oldStartDate;
      this.form.endDate = this.oldEndDate;
      this.form.deliveredBy = this.oldDeliveredBy;
      this.form.deliveredTo = this.oldDeliveredTo;
      this.form = _.cloneDeep(this.form);
    },
    processCertificat() {
      try {
        // Traiter le certificat PEM collé dans le textarea
        const certificate = forge.pki.certificateFromPem(this.certificateText);

        // Extraire les informations du certificat
        // const subjectAttributes = certificate.subject.attributes
        // const commonNameAttribute = subjectAttributes.find(attr => attr.name === 'commonName')
        // this.form.name = commonNameAttribute ? commonNameAttribute.value : 'Nom non trouvé'

        this.form.startDate = certificate.validity.notBefore
          .toLocaleString()
          .toString();
        this.form.endDate = certificate.validity.notAfter
          .toLocaleString()
          .toString();

        certificate.issuer.attributes.forEach((element) => {
          if (element.name == "commonName") {
            this.form.deliveredBy = element.value;
          }
        });
        certificate.subject.attributes.forEach((element) => {
          if (element.name == "commonName") {
            this.form.deliveredTo = element.value;
          }
        });

        // Reconversion du certificat en format PEM (pour l'affichage)
        this.form.certificate = forge.pki.certificateToPem(certificate);

        // Réinitialiser le message d'erreur s'il y en avait
        this.errorMessage = "";
      } catch (err) {
        // En cas d'erreur, afficher un message
        this.errorMessage = this.$i18n.t(
          "common.security.pem_certificate_parsing_error",
        );
        this.form.certificate = "";
        this.form.startDate = "";
        this.form.endDate = "";
        this.form.deliveredBy = "";
        this.form.deliveredTo = "";
      }
    },
    handleFileUploadCertificat(event, index = null) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const pemContent = e.target.result;

        try {
          const certificate = forge.pki.certificateFromPem(pemContent);
          const pemFormattedCert = forge.pki.certificateToPem(certificate);

          this.certificateText = forge.pki.certificateToPem(certificate);

          const startDate = certificate.validity.notBefore
            .toLocaleString()
            .toString();
          const endDate = certificate.validity.notAfter
            .toLocaleString()
            .toString();

          const subjectAttributes = certificate.subject.attributes;
          const commonNameAttribute = subjectAttributes.find(
            (attr) => attr.name === "commonName",
          );
          const name = commonNameAttribute
            ? commonNameAttribute.value
            : "Nom non trouvé";

          certificate.issuer.attributes.forEach((element) => {
            if (element.name == "commonName") {
              this.form.deliveredBy = element.value;
            }
          });
          certificate.subject.attributes.forEach((element) => {
            if (element.name == "commonName") {
              this.form.deliveredTo = element.value;
            }
          });

          if (index == null) {
            this.form.certificate = pemFormattedCert;
            this.form.startDate = startDate;
            this.form.endDate = endDate;
            this.form.nameDisplay = name;
          } else {
            this.certificatList[index].certificate = pemFormattedCert;
            this.certificatList[index].startDate = startDate;
            this.certificatList[index].endDate = endDate;
            this.certificatList[index].nameDisplay = name;
          }
        } catch (err) {
          console.error(
            this.$i18n.t("common.security.pem_certificate_parsing_error"),
            err,
          );
        }
      };

      reader.readAsText(file);
    },
    cancelPrivateKey() {
      this.form.statePrivateKey = 1;
      this.privateKeyText = "";
      this.form.startDate = this.oldStartDate;
      this.form.endDate = this.oldEndDate;
      this.form = _.cloneDeep(this.form);
    },
    processPrivateKey() {
      try {
        // Traiter le certificat PEM collé dans le textarea
        let privateKey = forge.pki.privateKeyFromPem(this.privateKeyText);

        // Convertir l'objet clé privée en format PEM pour l'afficher
        this.form.privateKey = forge.pki.privateKeyToPem(privateKey);

        // Réinitialiser le message d'erreur s'il y en avait
        this.errorMessage = "";
      } catch (err) {
        // En cas d'erreur, afficher un message
        this.errorMessage = this.$i18n.t(
          "common.security.pem_certificate_parsing_error",
        );
        this.form.certificate = "";
        this.privateKeyText = "";
      }
    },
    handleFileUploadPrivateKey(event) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const keyContent = e.target.result;

        try {
          const privateKey = forge.pki.privateKeyFromPem(keyContent);
          this.form.privateKey = forge.pki.privateKeyToPem(privateKey);
          this.privateKeyText = forge.pki.privateKeyToPem(privateKey);
        } catch (err) {
          console.error(
            this.$i18n.t("common.security.pem_certificate_parsing_error"),
            err,
          );
        }
      };

      reader.readAsText(file);
    },
    loadCompanies() {
      this.activateSpinner = true;

      const accountId = Number(this.accountId);

      this.$engine.company
        .getCompanies()
        .then((resp) => {
          const allCompanies = resp.data.companies || [];

          // Récupérer la racine et tous ses enfants
          const companies = this.getCompanyTree(allCompanies, accountId);

          companies.forEach((company) => {
            company.id = Number(company.id_account);
            company.children = [];
          });

          this.companies = this.buildCompanyTree(companies);

          this.activateSpinner = false;
        })
        .catch((error) => {
          this.activateSpinner = false;
          errorMessageAlert(error, this);
        });
    },
    buildCompanyTree(companies) {
      const companyMap = {};
      const roots = [];

      companies.forEach((company) => {
        companyMap[company.id_account] = {
          id: Number(company.id_account),
          name: company.name,
          prefix:
            Number(company.id_account) === Number(this.accountId) ? "R:" : "",
          id_parent: company.id_parent,
          children: [],
        };
      });

      companies.forEach((company) => {
        const currentCompany = companyMap[company.id_account]
        const parentId = Number(company.id_parent)

        if (
          Number(company.id_account) === Number(this.accountId) ||
          !companyMap[parentId]
        ) {
          roots.push(currentCompany)
        } else {
          companyMap[parentId].children.push(currentCompany)
        }
      })

      return roots
    },
    getCompanyTree(companies, accountId) {
      const result = []
      const ids = new Set([Number(accountId)])

      let hasNewCompany = true

      while (hasNewCompany) {
        hasNewCompany = false

        companies.forEach((company) => {
          const companyId = Number(company.id_account)
          const parentId = Number(company.id_parent)

          if (ids.has(parentId) && !ids.has(companyId)) {
            ids.add(companyId)
            hasNewCompany = true
          }
        })
      }

      companies.forEach((company) => {
        if (ids.has(Number(company.id_account))) {
          result.push(company)
        }
      })

      return result
    },
    getActiveStatus(startDate, endDate) {
      const now = moment()
      const start = moment(startDate, [
        'DD/MM/YYYY HH:mm:ss',
        'YYYY-MM-DD HH:mm:ss',
        moment.ISO_8601
      ])
      const end = moment(endDate, [
        'DD/MM/YYYY HH:mm:ss',
        'YYYY-MM-DD HH:mm:ss',
        moment.ISO_8601
      ])

      if (!start.isValid() || !end.isValid()) {
        return '0'
      }

      // Pas encore commencé
      if (now.isBefore(start)) {
        return '1'
      }

      // Certificat expiré
      if (now.isAfter(end)) {
        return '0'
      }

      // Certificat actuellement actif
      return '2'
    },
    buildSettingsParameter() {
      const settingsGroups = [
        {
          label: this.$t('mandate.remittance_generation.sdd_remittance_file_generation'),
          mode: this.generationModeSDD,
          frequency: this.generationFrequencySDD,
          time: this.generationTimeSDD,
          names: {
            mode: 'SDDRemitttanceFileGenerationMode',
            frequency: 'SDDRemitttanceFileGenerationFrequency',
            time: 'SDDRemitttanceFileGenerationInterval'
          }
        },
        {
          label: this.$t('mandate.remittance_generation.sct_remittance_file_generation'),
          mode: this.sctFileGenerationMode,
          frequency: this.sctFileGenerationFrequency,
          time: this.sctFileGenerationTime,
          names: {
            mode: 'SCTRemitttanceFileGenerationMode',
            frequency: 'SCTRemitttanceFileGenerationFrequency',
            time: 'SCTRemitttanceFileGenerationInterval'
          }
        },
        {
          label: this.$t('mandate.remittance_generation.sdd_remittance_generation'),
          mode: this.generationMode,
          frequency: this.generationFrequency,
          time: this.generationTime,
          names: {
            mode: 'SDDRemitttanceGenerationMode',
            frequency: 'SDDRemitttanceGenerationFrequency',
            time: 'SDDRemitttanceGenerationInterval'
          }
        },
        {
          label: this.$t('mandate.remittance_generation.sct_remittance_generation'),
          mode: this.sctGenerationMode,
          frequency: this.sctGenerationFrequency,
          time: this.sctGenerationTime,
          names: {
            mode: 'SCTRemitttanceGenerationMode',
            frequency: 'SCTRemitttanceGenerationFrequency',
            time: 'SCTRemitttanceGenerationInterval'
          }
        }
      ];

      const isEmpty = value =>
        value === undefined || value === null || value === '';

      for (const group of settingsGroups) {
        if (isEmpty(group.mode)) {
          this.$f7.alert(this.$t('mandate.remittance_generation.select_generation_mode', { label: group.label }), 'Erreur');
          return;
        }

        if (group.mode === 'auto') {
          if (isEmpty(group.frequency)) {
            this.$f7.alert(this.$t('mandate.remittance_generation.select_generation_frequency', { label: group.label }), 'Erreur');
            return;
          }

          if (isEmpty(group.time)) {
            this.$f7.alert(this.$t('mandate.remittance_generation.select_generation_time', { label: group.label }), 'Erreur');
            return;
          }
        }
      }
      if (isEmpty(this.expiringMandatesType)) {
        this.$f7.alert(this.$t('mandate.remittance_generation.select_expiring_mandates_type'), 'Erreur');
        return;
      }
      // const settings = settingsGroups.flatMap(group => {
      //   const parameters = [
      //     {
      //       parameterName: group.names.mode,
      //       parameterValue: group.mode
      //     }
      //   ];
      //
      //   // La fréquence et l'heure ne sont envoyées qu'en mode automatique.
      //   if (group.mode === 'auto') {
      //     parameters.push(
      //       {
      //         parameterName: group.names.frequency,
      //         parameterValue: group.frequency
      //       },
      //       {
      //         parameterName: group.names.time,
      //         parameterValue: group.time
      //       }
      //     );
      //   }
      //
      //   return parameters;
      // });
      // settings.push({
      //   parameterName: 'MandateExpiredExtract',
      //   parameterValue: this.expiringMandatesType
      // })
      const parameter = {};

      settingsGroups.forEach(group => {
        parameter[group.names.mode] = group.mode;

        if (group.mode === 'auto') {
          parameter[group.names.frequency] = group.frequency;
          parameter[group.names.time] = group.time;
        }
      });

      parameter.MandateExpiredExtract = this.expiringMandatesType;
      return parameter
    },
    convertToDbDateTime(dateTimeStr) {
      if (!dateTimeStr) return ''

      const [date, time] = dateTimeStr.split(' ')
      const [day, month, year] = date.split('/')

      return `${year}-${month}-${day} ${time}`
    }
  }
}
</script>
<style scoped>

.sdd-select {
  display: block;
  width: 90px;
}

.justify-content-around label {
  display: block;
  font-size: 0.82rem;
  color: #6c757d;
  margin-bottom: 2px;
}

.justify-content-around label.sdd-label-main,
.d-flex label.sdd-label-main {
  font-size: 1rem !important;
  color: #212529 !important;
  margin-bottom: 1rem !important;
}
.sdd-select-header label {
  display: block;
  text-align: center;
  font-size: 1rem !important;
  color: #212529 !important;
  margin-bottom: 2px;
}
.justify-content-around label:not(.sdd-label-main) {
  font-size: 1rem !important;
  color: #212529 !important;
}
.sdd-generation-settings {
  padding: 5px 0 10px 300px;
}
.sct-generation-settings {
  padding: 5px 0 10px 300px;
}
.sct-file-generation-settings {
  padding: 5px 0 10px 300px;
}
.expiring-mandates-settings {
  padding: 5px 0 10px 280px;
}
.generation-row {
  margin-bottom: 2px;
}

.custom-control {
  min-height: 18px;
  padding-left: 25px;
}

.custom-control-label::before,
.custom-control-label::after {
  width: 12px;
  height: 12px;
  top: 3px;
}
.interval-row {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 25px;
}

.interval-selects {
  display: flex;
  gap: 5px;
  margin-left: 100px;
  margin-top: -2px;
}

.interval-selects select {
  width: 130px;
}
.interval-selects-type {
  display: flex;
  gap: 5px;
  margin-left: 225px;
  margin-top: -2px;
}

.interval-selects-type select {
  width: 160px;
}


.sct-file-row {
  display: flex;
  align-items: flex-start;
}

.sct-file-options {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  margin-top: -4px;
}

.sct-file-options .custom-checkbox {
  margin-bottom: 4px;
}
.space {
  margin-left: 10px;
}
</style>
<style>
.normal-font label,
.normal-font input,
.normal-font .form-control {
  font-weight: normal !important;
}
</style>
